import React from "react";
import ProductGroupCard from "./ProductGroupCard";

const ProductGroups = ({
  productGroups,
  setShowProdGroups,
  setSelectedProdGroup,
  setProdGroupEdits,
}) => {
  return (
    <div className='productGroups'>
      {productGroups
        ? Object.keys(productGroups)
            .sort()
            .map((key) => {
              return (
                <ProductGroupCard
                  key={key}
                  name={key}
                  data={productGroups[key]}
                  setShowProdGroups={setShowProdGroups}
                  setSelectedProdGroup={setSelectedProdGroup}
                  setProdGroupEdits={setProdGroupEdits}
                />
              );
            })
        : ""}
    </div>
  );
};

export default ProductGroups;
